import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PropertyCard from '../components/PropertyCard';

export default function SearchResult() {
  const location = useLocation();
  const navigate = useNavigate();
  const [filteredProps, setFilteredProps] = useState([]);
  const [loading, setLoading] = useState(true);

  // preluam filtrele din state
  const filters = location.state || {};
  const {
    query = '',
    location: loc = '',
    checkIn = '',
    checkOut = '',
    checkLater = false,
    adults = 1,
    children = 0,
    propertyType = '',
    minPrice = '',
    maxPrice = '',
    selectedGeneral = [],
    selectedAgro = [],
    selectedRooms = []
  } = filters;

  useEffect(() => {
    setLoading(true);

    fetch('/api/properties/search', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(filters)
    })
      .then(res => res.json())
      .then(data => {
        setFilteredProps(data);
        setLoading(false);
      })
      .catch(() => {
        setFilteredProps([]);
        setLoading(false);
      });
  }, [
    query, loc, checkIn, checkOut, checkLater,
    adults, children, propertyType, minPrice, maxPrice,
    selectedGeneral, selectedAgro, selectedRooms
  ]);

  if (loading) return <p>Se incarca proprietatile...</p>;
  if (!filteredProps.length) return <p>Nu s-au gasit proprietati pentru criteriile selectate.</p>;

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '1rem' }}>
      <h2 style={{ marginBottom: '1rem' }}>Rezultatele cautarii</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(280px,1fr))', gap: '1rem' }}>
        {filteredProps.map(p => (
          <PropertyCard key={p._id} p={p} />
        ))}
      </div>
      <button
        style={{
          marginTop: '1rem',
          backgroundColor: '#006d77',
          color: 'white',
          padding: '0.5rem 1rem',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer'
        }}
        onClick={() => navigate(-1)}
      >
        ⬅ Inapoi
      </button>
    </div>
  );
}
